import "./style/style.scss";
import { RoutingPage } from "./routing/RoutingPage";
import { Footer } from "designsystem/src/stories/Components/Footer";
import { globals } from "./globals";
import i18next, { t } from "i18next";
import { getCompanyDomain } from "fidodemo/src/utils/utils";
import { CookieBanner } from "./CookieBanner";
import { MainStyle } from "designsystem/src/stories/Components/MainStyle/MainStyle";
import { Heading } from "designsystem/src/stories/Elements/Heading";
import { Navigation } from "designsystem/src/stories/Components/Navigation";
import { openLinkSafely } from "designsystem/src/utils";

export function App() {
	const companyDomain = getCompanyDomain();
	const meBaseUrl = location.origin.replace("https://fidodemo", "https://me");

	function openFaqUrl() {
		let url: string;
		if (i18next.resolvedLanguage?.includes("de")) {
			url = "https://evarooms.merckgroup.com/Topic/EUS/de-de/projekte/moving-beyond-passwords";
		} else {
			url = "https://evarooms.merckgroup.com/Topic/EUS/en-us/projects/moving-beyond-passwords/faq";
		}
		openLinkSafely(url);
	}

	return <>
		<Navigation entries={[{ id: "navigation-faq", icon: "message-chat-square", i18nLabel: "navigation.faq.label", onClick: openFaqUrl }]} />
		<div className={"main-container-wrapper"}>
			<MainStyle />
			<div className={"main-content-wrapper"}>
				<div className={"main-page-wrapper"}>
					<div className={"main-heading"}>
						<Heading text={t("fidodemo.heading")} type="h3" />
					</div>
					<RoutingPage />
				</div>
			</div>
			<br />
			<br />
			<Footer companyName={companyDomain}
							showGenderInfo={(i18next && i18next.language.startsWith("de"))}
							version={globals.versionInfo}
							meBaseUrl={meBaseUrl}
			/>
			<CookieBanner />
		</div>
	</>;
}
